/* template */
<template><page><base-container :class='["action-sheet-page"]'><div :class='["btn-item"]'><active-sheet/></div><div :class='["btn-item"]'><sheet/></div><div :class='["btn-item"]'><picker-sheet/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_490ad7ae"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_490ad7ae"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_490ad7ae"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_490ad7ae"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'active-sheet':getComponent(require("./action-sheet-active.mpx?isComponent&outputPath=components%2Faction-sheet-active765dd307%2Findex")),'sheet':getComponent(require("./action-sheet.mpx?isComponent&outputPath=components%2Faction-sheet9f5bbbcc%2Findex")),'picker-sheet':getComponent(require("./action-sheet-picker.mpx?isComponent&outputPath=components%2Faction-sheet-pickerb0594ee2%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>